import React from 'react'
import { BetInfo } from '@mobi/betslip/Components/Common/BetInfo'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { InlineAlert } from '@mobi/betslip/Components/Common/InlineAlert'
import { BetInvestment } from '@mobi/betslip/Components/Singles/Components/SingleItem/Components/BetInvestment'
import { MultiItems } from '@mobi/betslip/Components/Multi/Components/MultiItems'
import { ShareBetContext } from '@mobi/betslip/context'
import type { BetSlipShare as BetSlipShareType } from '@core/Areas/ShareBet/types'

export const BetSlipShare: React.FC<{
  share: BetSlipShareType['share']
  isCostShared: boolean
}> = ({ share: { items, isBetPlaced, multiReceipt }, isCostShared }) => {
  const isMultiBet = items.length > 1

  return (
    <div>
      <ShareBetContext.Provider value={true}>
        <BetCard.Container
          topComponent={
            isBetPlaced ? (
              <InlineAlert type='warning' text='PENDING' hasIcon={false} isCenterAlign />
            ) : null
          }
        >
          {isMultiBet ? (
            <MultiItems
              multiItems={items}
              isEditable={false}
              hasValidMultiInvestment={isCostShared}
              appliedBonus={multiReceipt?.bonusBet}
            />
          ) : (
            <>
              <BetInfo item={items[0]} />

              {isCostShared && <BetInvestment item={items[0]} />}
            </>
          )}
        </BetCard.Container>
      </ShareBetContext.Provider>
    </div>
  )
}
